<template>
  <div v-if="useDocumentDownloader().showModal()" class="linker-wrapper">
    <div class="linker-wrapper-inner">
      <div class="sub-header-text text-center">
        <span v-if="!useDocumentDownloader().isGenerated()">
          Getting your document ready...
        </span>
        <span v-else-if="isWaiting"> Updating your documents... </span>
        <span v-else> All set! Let's go! </span>
      </div>

      <base-spinner
        v-if="!useDocumentDownloader().isGenerated() || isWaiting"
        large
        dark
        class="mt-2"
      />

      <template v-else>
        <base-button class="mt-1" set-width @click="handleDownload">
          Download
          <base-icon icon="file-arrow-down" />
        </base-button>
      </template>
    </div>
  </div>
</template>

<script setup>
import { useDownloaderStore } from "~/stores/useDownloaderStore";

const isWaiting = ref(false);

const goExternal = (link) => {
  window.open(link, "_blank");
  useDocumentDownloader().doDocumentMarkAsRead();
};

const handleDownload = async () => {
  const downloaderStore = useDownloaderStore();

  goExternal(useDocumentDownloader().getFinalLink());

  isWaiting.value = true;

  await new Promise((resolve) => setTimeout(resolve, 2000));

  if (downloaderStore.refreshDocuments) {
    await downloaderStore.refreshDocuments();
  }

  isWaiting.value = false;
  useDocumentDownloader().hideDownloader();
};
</script>
